import type { FC } from 'react';
import { useIntl } from 'react-intl';

import { formatAmount } from '@xing-com/crate-entity-pages-common';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { EntityInfo } from './entity-info';

export const EntityInfoPublisherPage: FC = () => {
  const intl = useIntl();
  const { pageContext } = usePageContext();
  const followersTotal = pageContext.followersTotal;

  const entityInfoData = [];

  if (followersTotal && followersTotal > 0) {
    entityInfoData.push({
      value: formatAmount({ value: followersTotal, intl }),
      label: ` ${intl.formatMessage({
        id: followersTotal > 1 ? 'EP_FOLLOWERS.other' : 'EP_FOLLOWERS.one',
      })}`,
      testId: 'HEADER_FOLLOWERS_TOTAL',
    });
  }

  return <EntityInfo data={entityInfoData} />;
};
